import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { useFrozenSupplierTabBreadcrumbs } from "Helpers/useFrozenSupplierBreadcrumbs";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Vendor  } from "assets/SideBarIcons/vendor.svg";
import SupplierTabs from "./SupplierTabs";
import { Box } from "@mui/material";
import StockReceivedListing from "pages/Inventory/StockReceivedListing";
export default function SupplierStockReceives() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const params = useParams();
    const breadcrumbItems = useFrozenSupplierTabBreadcrumbs("Stock Received");
    return (<>
        <ComponentHeaderTwo
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate('/suppliers')}
            onSubmit={() => {}}
            heading={t('vendor')}
            icon={<Vendor height={28} width={28} />}
            btnText={"back"}
            btnType={"back"}
            showCreateBtn={false}
            breadcrumbItems={breadcrumbItems}
        />
        <Box className={`flex`}>
            <SupplierTabs params={params} selectedIndex={3} />
            <Box className='mt-[10px] w-[100%]'>
                <StockReceivedListing supplierId={+(params as any)?.id} />
            </Box>
        </Box>
    </>)
}
